import _ from 'lodash'
import React from 'react'
import { canViewPrimaryContact } from '../../State/Permissions/HasPermissions'
import { Link } from '@tanstack/react-router'

export const InvoiceReportColumns = (report) => ({
    description: {
        id: 'description',
        label: 'Invoice #',
        type: 'text',
        width: 15,
        value: (row) => row.ref,
        component: ({ value, stores }) => {
            const { row } = stores
            return (
                <div>
                    <Link
                        to={`/invoices/${row.rowObject.invoiceId || row.rowObject.id}`}
                    >
                        {' '}
                        {value}
                    </Link>
                </div>
            )
        },
    },
    issuedOn: {
        id: 'issuedOn',
        label: 'Issue Date',
        type: 'date',
        width: 10,
        value: (row) => (row.issuedOn ? new Date(row.issuedOn) : null),
    },
    dueDate: {
        id: 'dueDate',
        label: 'Due Date',
        type: 'date',
        width: 10,
        value: (row) => (row.dueDate ? new Date(row.dueDate) : null),
    },
    startDate: {
        id: 'startDate',
        label: 'Work Start Date',
        type: 'date',
        width: 10,
        value: (row) => (row.startDate ? new Date(row.startDate) : null),
    },
    endDate: {
        id: 'endDate',
        label: 'Work End Date',
        type: 'date',
        width: 10,
        value: (row) => (row.endDate ? new Date(row.endDate) : null),
    },
    createdAt: {
        id: 'createdAt',
        label: 'Creation Date',
        type: 'date',
        width: 10,
        value: (row) => (row.createdAt ? new Date(row.createdAt) : null),
    },
    project: {
        id: 'project',
        label: 'Project',
        type: 'project',
        width: 20,
        value: (row) => row.project,
        format: (project) => {
            return project
        },
    },
    projectTitle: {
        id: 'projectTitle',
        label: 'Project Title',
        type: 'text',
        width: 20,
        visible: false,
        value: (row) => row.project,
    },
    contact: {
        id: 'contact',
        label: 'Client',
        type: 'contact',
        width: 20,
        value: (row) => row.contact,
        format: (contact) => contact,
    },
    projectContact: {
        id: 'projectContact',
        label: 'Project Client',
        type: 'contact',
        width: 20,
        value: (row) => row.contact,
        format: (contact) => contact,
    },
    projectOwner: {
        id: 'projectOwner',
        label: 'Project Owner',
        type: 'staffMember',
        width: 20,
        value: (row) => row.projectOwner,
        format: (staff) => staff,
    },
    projectPrimaryContact: {
        id: 'projectPrimaryContact',
        label: 'Project Primary Contact',
        type: 'contact',
        width: 20,
        value: (row) => row.projectPrimaryContact,
        format: (contact) => contact,
        permissions: (row) => canViewPrimaryContact(),
    },
    costCentre: {
        id: 'costCentre',
        label: 'Cost Centre',
        type: 'costCentre',
        width: 15,
        value: (row) => row.costCentre,
        format: (costCentre) => costCentre,
    },
    amountExTax: {
        id: 'amountExTax',
        label: 'Amount exc. Tax',
        type: 'currency',
        width: 10,
        value: (row) => row.amountExTax,
    },
    amountIncTax: {
        id: 'amountIncTax',
        label: 'Amount inc. Tax',
        type: 'currency',
        width: 10,
        value: (row) => row.amountIncTax,
    },
    amountTax: {
        id: 'amountTax',
        label: 'Tax Amount',
        type: 'currency',
        width: 10,
        value: (row) => row.amountTax,
    },
    agreedFeeExTax: {
        id: 'agreedFeeExTax',
        label: 'Agreed Fee Amount exc. Tax',
        type: 'currency',
        width: 10,
        value: (row) => row.agreedFeeExTax,
    },
    variationExTax: {
        id: 'variationExTax',
        label: 'Variation Amount exc. Tax',
        type: 'currency',
        width: 10,
        value: (row) => row.variationExTax,
    },
    agreedFeeVariationExTax: {
        id: 'agreedFeeVariationExTax',
        label: 'Agreed Fee + Variation Amount exc. Tax',
        type: 'currency',
        width: 10,
        value: (row) => row.agreedFeeVariationExTax,
    },
    reimbursementExTax: {
        id: 'reimbursementExTax',
        label: 'Reimbursement Amount exc. Tax',
        type: 'currency',
        width: 10,
        value: (row) => row.reimbursementExTax,
    },
    agreedFeeTax: {
        id: 'agreedFeeTax',
        label: 'Agreed Fee Tax',
        type: 'currency',
        width: 10,
        value: (row) => row.agreedFeeTax,
    },
    variationTax: {
        id: 'variationTax',
        label: 'Variation Tax',
        type: 'currency',
        width: 10,
        value: (row) => row.variationTax,
    },
    agreedFeeVariationTax: {
        id: 'agreedFeeVariationTax',
        label: 'Agreed Fee + Variation Tax',
        type: 'currency',
        width: 10,
        value: (row) => row.agreedFeeVariationTax,
    },
    reimbursementTax: {
        id: 'reimbursementTax',
        label: 'Reimbursement Tax',
        type: 'currency',
        width: 10,
        value: (row) => row.reimbursementTax,
    },
    agreedFeeIncTax: {
        id: 'agreedFeeIncTax',
        label: 'Agreed Fee Amount inc. Tax',
        type: 'currency',
        width: 10,
        value: (row) => row.agreedFeeIncTax,
    },
    variationIncTax: {
        id: 'variationIncTax',
        label: 'Variation Amount inc. Tax',
        type: 'currency',
        width: 10,
        value: (row) => row.variationIncTax,
    },
    agreedFeeVariationIncTax: {
        id: 'agreedFeeVariationIncTax',
        label: 'Agreed Fee + Variation Amount inc. Tax',
        type: 'currency',
        width: 10,
        value: (row) => row.agreedFeeVariationIncTax,
    },
    reimbursementIncTax: {
        id: 'reimbursementIncTax',
        label: 'Reimbursement Amount inc. Tax',
        type: 'currency',
        width: 10,
        value: (row) => row.reimbursementIncTax,
    },
    synced: {
        id: 'synced',
        label: 'Synced',
        type: 'boolean',
        width: 10,
        value: (row) => row.synced,
    },
    projectStatus: {
        id: 'projectStatus',
        label: 'Project Status',
        type: 'status',
        width: 10,
        value: (row) => row.projectStatus || 'archived',
    },
})
